import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-svg",
  templateUrl: "./icon-svg.component.html",
  styleUrl: "./icon-svg.component.scss",
  standalone: false,
})
export class IconSvgComponent {
  @Input() classes: string = "";
  @Input({ required: true }) icon!: string;
}
